'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMrAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 6.94394e-06C9.33333 -6.54348e-05 18.6667 0 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V6.94394e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 6.94394e-06L28 0V20H0V6.94394e-06Z", fill: "#108B4D" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.8134 7.73335C19.862 8.04079 19.8872 8.35599 19.8872 8.67708C19.8872 11.9908 17.2009 14.6771 13.8872 14.6771C10.5735 14.6771 7.88721 11.9908 7.88721 8.67708C7.88721 8.35599 7.91243 8.04079 7.961 7.73335C8.41369 10.5987 10.8946 12.7896 13.8872 12.7896C16.8798 12.7896 19.3607 10.5987 19.8134 7.73335ZM13.9998 8.56411L12.3517 9.73899L12.9598 7.8085L11.3331 6.60413L13.357 6.58591L13.9998 4.66669L14.6425 6.58591L16.6664 6.60413L15.0398 7.8085L15.6479 9.73899L13.9998 8.56411Z",
          fill: "#FFC941"
        }
      )
    ]
  }
);
const VpFlagMrAsset = forwardRef(FlagMrAsset);

export { VpFlagMrAsset as default };
